export default __webpack_public_path__ + "static/thumb-landscape-072f4eae4f3412aa1cb4afa92a3f9a18.jpg";